<template>
  <div>
          <div>
            <b-card no-body>
              <DeviceAdminSUP/>
              </b-card>
              </div>
              </div>
              <!-- <b-tabs v-model="AssetTabs" card>
                <b-tab
                  title="Clarence Devices"
                  :disabled="
                    !UserAccess.includes('CLA') &&
                      !this.UserProfile.includes('SYS') &&
                      !this.UserProfile.includes('SUP')
                  "
                  lazy
                >
                  <b-card-text>
                    <b-tabs>
                      <b-card>import other stuff here?</b-card>
                    <b-tab title = "C1 Devices" lazy>
                      <b-table
                      sticky-header
                      id="C1Table"
                      :items="c1items"
                      :fields="fields"
                      no-border-collapse
                      hover
                      show-empty
                      empty-text="You currently dont have any Assets of this type"
                      responsive
                      small
                    > -->
                      <!-- this.IDSwitchToHuman() -->
                      <!-- <template v-slot:cell(show_details)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="showClarenceModal(item, 'Clarence-C1')"
                        >
                          Details
                        </b-button>
                      </template>

                      <template v-slot:cell(ID)="{ item }">
                        {{ getNewName(item) }}
                      </template>
                    </b-table>
                    </b-tab>
                    <b-tab title = "O1 Devices" lazy>
                      <b-table
                      sticky-header
                      id="O1Table"
                      :items="o1items"
                      :fields="fields"
                      no-border-collapse
                      hover
                      show-empty
                      empty-text="You currently dont have any Assets of this type"
                      responsive
                      small
                    > -->
                      <!-- this.IDSwitchToHuman() -->
                      <!-- <template v-slot:cell(show_details)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="showClarenceModal(item, 'Clarence-C1')"
                        >
                          Details
                        </b-button>
                      </template>

                      <template v-slot:cell(ID)="{ item }">
                        {{ getNewName(item) }}
                      </template>
                    </b-table>
                    </b-tab>
                    </b-tabs>
                    <div> -->
                      <!-- <b-card>
                        <b-row>
                          <b-col cols="5">
                            <label> Risk Level </label> <br />
                            <b-form-select v-model="dbFilterRiskLevel">
                              <option selected null>No Risk Filter</option>
                              <option value="1">Extremely High Risk</option>
                              <option value="2">High Risk</option>
                              <option value="3">Moderate Risk</option>
                              <option value="4">Low Risk</option>
                            </b-form-select>
                          </b-col>
                          <b-col cols="5">
                            <label> Filter by Feed </label>
                            <b-list-group class="" horizontal="md">
                              <b-list-group-item>
                                <b-form-checkbox
                                  v-model="dbFilterOutdoor"
                                  class="checkboxDiv"
                                  >Outdoor</b-form-checkbox
                                >
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox
                                  v-model="dbFilterHot"
                                  class="checkboxDiv"
                                  >Hot</b-form-checkbox
                                >
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox
                                  v-model="dbFilterCold"
                                  class="checkboxDiv"
                                  >Cold</b-form-checkbox
                                >
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox
                                  v-model="dbFilterMixed"
                                  class="checkboxDiv"
                                  >Mixed</b-form-checkbox
                                >
                              </b-list-group-item>
                              <b-list-group-item>
                                <b-form-checkbox
                                  v-model="dbFilterReturn"
                                  class="checkboxDiv"
                                  >Return</b-form-checkbox
                                >
                              </b-list-group-item>
                            </b-list-group>
                          </b-col>
                        </b-row>
                        <br />

                        <b-button
                          variant="outline-secondary"
                          @click="filterEndpointData('Clarence')"
                          size="sm"
                          >Apply filter</b-button
                        ><b-button
                          variant="outline-secondary"
                          @click="resetValue('Clarence')"
                          size="sm"
                          >Clear filter</b-button
                        >
                        <br />
                        <b-row>
                          <b-col class="text-left" cols="2">
                            <p class="filterhead">Current Filters:</p>
                          </b-col>
                          <b-col v-if="this.filterInfo.length == 0"
                            ><p class="filterbody">No Filters</p></b-col
                          >
                          <b-col
                            v-for="(id, idx) in this.filterInfo"
                            :key="idx"
                            class="text-left"
                            cols="3"
                          >
                            <p class="filterbody">
                              {{ id.FilterName }}-<em>{{ id.FilterVar }},</em>
                            </p>
                          </b-col>
                        </b-row>
                      </b-card> -->
                      <!-- </b-collapse> -->
                    <!-- </div>
                    <br />
                   
                  </b-card-text>
                </b-tab>
                <b-tab title="Routers" lazy>
                  <Routers />
                </b-tab> -->

                <!-- <b-tab
                  title="Washbasin Units"
                  :disabled="
                    !UserAccess.includes('WBU') &&
                      !this.UserProfile.includes('SYS') &&
                      !this.UserProfile.includes('SUP')
                  "
                  lazy
                >
                  <b-card-text>
                    <div>
                      <b-card>
                        <b-row>
                          <b-col cols="5">
                            <label> Risk Level </label> <br />
                            <b-form-select v-model="dbFilterRiskLevel">
                              <option selected null>No Risk Filter</option>
                              <option value="1">Extremely High Risk</option>
                              <option value="2">High Risk</option>
                              <option value="3">Moderate Risk</option>
                              <option value="4">Low Risk</option>
                            </b-form-select>
                          </b-col>
                        </b-row>
                        <br />
                        <b-button
                          variant="outline-secondary"
                          @click="filterEndpointData('Washbasin')"
                          size="sm"
                          >Apply filter</b-button
                        ><b-button
                          variant="outline-secondary"
                          @click="resetValue('Washbasin')"
                          size="sm"
                          >Clear filter</b-button
                        >
                        <b-row>
                          <b-col class="text-left" cols="2">
                            <p class="filterhead">Current Filters:</p>
                          </b-col>
                          <b-col v-if="this.filterInfo.length == 0"
                            ><p class="filterbody">No Filters</p></b-col
                          >
                          <b-col
                            v-for="(id, idx) in this.filterInfo"
                            :key="idx"
                            class="text-left"
                            cols="3"
                          >
                            <p class="filterbody">
                              {{ id.FilterName }}-<em>{{ id.FilterVar }},</em>
                            </p>
                          </b-col>
                        </b-row>
                      </b-card>
                                          </div>
                    <br />
                    <b-table
                      sticky-header
                      id="WashbasinTable"
                      :items="basinitems"
                      :fields="basinfields"
                      no-border-collapse
                      hover
                      show-empty
                      empty-text="You currently dont have any Assets of this type"
                      responsive
                      small
                    >
                      <template v-slot:cell(show_details)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="showWashbasinModal(item, 'Handwash Unit')"
                        >
                          Details
                        </b-button>
                      </template>
                    </b-table>
                  </b-card-text>
                </b-tab> -->
                <!-- <b-tab title="Outlets" lazy>
                  <b-card-text>
                    <b-card>
                      <b-row>
                        <b-col>
                          <label> Outlet Type </label> <br />
                          <b-form-select v-model="dbFilterOutletType">
                            <option selected null>No Type Filter</option>
                            <option value="1">Cold Tap</option>
                            <option value="2">Hot Tap</option>
                            <option value="3">Mixed Tap</option>
                            <option value="4">Shower</option>
                            <option value="5">Other</option>
                          </b-form-select>
                        </b-col>
                        <b-col>
                          <label> Sentinel </label> <br />
                          <b-form-select v-model="dbFilterSentinel">
                            <option selected null>No Sentinel Filter</option>
                            <option value="1">Sentinel Only</option>
                          </b-form-select>
                        </b-col>
                      </b-row>
                      <br />
                      <b-button
                        variant="outline-secondary"
                        @click="filterEndpointData('Outlet')"
                        size="sm"
                        >Apply filter</b-button
                      ><b-button
                        variant="outline-secondary"
                        @click="resetValue('Outlet')"
                        size="sm"
                        >Clear filter</b-button
                      >
                      <br />
                      <b-row>
                        <b-col class="text-left" cols="2">
                          <p class="filterhead">Current Filters:</p>
                        </b-col>
                        <b-col v-if="this.filterInfo.length == 0"
                          ><p class="filterbody">No Filters</p></b-col
                        >
                        <b-col
                          v-for="(id, idx) in this.filterInfo"
                          :key="idx"
                          class="text-left"
                          cols="3"
                        >
                          <p class="filterbody">
                            {{ id.FilterName }}-<em>{{ id.FilterVar }},</em>
                          </p>
                        </b-col>
                      </b-row>
                    </b-card>
                    <br />
                    <b-table
                      sticky-header
                      id="OutletTable"
                      :items="OutletTableData"
                      :fields="outletfields"
                      no-border-collapse
                      hover
                      show-empty
                      empty-text="You currently dont have any Assets of this type"
                      responsive
                      small
                    >
                      <template v-slot:cell(show_details)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="showOutletModal(item, 'Outlet')"
                        >
                          Details
                        </b-button>
                      </template>
                    </b-table>
                    <b-row>
                      <b-col>
                        <b-button
                          variant="outline-secondary"
                          size="sm"
                          @click="showAddOutletModal()"
                        >
                          <BIconPlusSquare></BIconPlusSquare> Add new Outlet
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-tab> -->
              <!-- </b-tabs>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div> -->
    <!-- <b-modal
      id="ClarenceDetails"
      title="Asset Details"
      ref="ClarenceDetails"
      content-class="Modal"
      header-bg-variant="light"
      footer-bg-variant="light"
      lazy
    >
      <b-card
        border-variant="dark"
        align="center"
        header-bg-variant="secondary"
        footer-tag="footer"
        header-text-variant="light"
      >
        <b-card-sub-title class="mb-2">{{ EndpointDept }}</b-card-sub-title>
        <template #header>
          <h4 class="centered">
            {{ EndpointCategory }} :
            {{ getNewName(EndpointID, EndpointCategory) }}
          </h4>
        </template>
        <b-card-body>
          <b-row
            ><b-col
              ><h5 v-if="this.EndpointCategory == 'C-1'">
                <em>Position: {{ this.EndpointPos }}</em>
              </h5>
              <h5>
                <em>Position Note: {{ this.EndpointPosNote }}</em>
              </h5>
            </b-col></b-row
          >

          <b-card
            header-bg-variant=""
            align="center"
            border-variant="info"
            header-text-variant=""
            footer-bg-variant=""
          >
            <template #header>
              <b-row align-v="center"
                ><b-col align-v="center"
                  ><h6>Current Groups: {{ EndpointSub }}</h6></b-col
                >
              </b-row>
            </template>
            <template #footer>
              <b-row no-gutters>
                <b-col
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-b-modal.ClarenceActionsModal
                    v-on:click="
                      ClarenceActions(
                        EndpointID,
                        EndpointCategory,
                        EndpointStatus
                      )
                    "
                    block
                    >Actions</b-button
                  ></b-col
                >
                <b-col
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-b-modal.DeviceDetailsModal
                    block
                    v-on:click="DeviceDetailReport(EndpointID, EndpointType)"
                    >Device Details</b-button
                  ></b-col
                >
                <b-col
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    block
                    v-on:click="DeviceReportGen(EndpointID, EndpointType)"
                    >Trend Report</b-button
                  ></b-col
                >
              </b-row>
            </template>
            <b-card v-if="this.EndpointList.length == 0"
              >Not Linked to any Location Groups</b-card
            >
            <b-list-group v-if="this.EndpointList.length != 0">
              <b-list-group-item v-for="item in this.EndpointList" :key="item">
                {{ item }}
              </b-list-group-item>
            </b-list-group>
            <br />
            <b-button
              variant="outline-info"
              v-on:click="showSubModal(EndpointID, EndpointType, EndpointList)"
              size="sm"
            >
              Edit Location Groups
            </b-button>
          </b-card>
          <b-row
            ><b-col><br /></b-col
          ></b-row>

          <b-row
            ><b-col><br /></b-col
          ></b-row>
        </b-card-body>
      </b-card>
    </b-modal>

    <b-modal
      id="ClarenceActionsModal"
      title="Clarence Device Actions"
      hide-footer
      ref="ClarenceActionsModal"
      content-class="Modal"
      header-bg-variant="dark"
      footer-bg-variant="info"
      header-text-variant="light"
    >
      <div v-if="Type == 'C-1'">
        <b-card no-body v-if="DeviceStatus == 'Active'"
          ><b-button
            variant="outline-info"
            block
            v-on:click="DeviceAction(ActionID, 'Suspend')"
            >Suspend</b-button
          ><br />
          <p class="infolabel">(Temporarily stop monitoring)</p></b-card
        >
        <b-card no-body v-if="DeviceStatus == 'Suspended'"
          ><b-button
            variant="outline-info"
            block
            v-on:click="DeviceAction(ActionID, 'Activate')"
            >Activate</b-button
          ><br />
          <p class="infolabel">
            (Restart monitoring if previously suspended)
          </p></b-card
        > -->
        <!-- <b-card-group v-if="!this.UserAccess.includes('CLI')">
          <b-card no-body
            ><b-button
              variant="outline-danger"
              block
              v-on:click="DeviceAction(ActionID, 'SuspendToRelocate')"
              >Suspend to Relocate</b-button
            ><br />
            <p class="infolabel">
              (If monitoring is to be stopped completely in this location, being
              moved to new location etc)
            </p></b-card
          >
          <b-card no-body
            ><b-button
              variant="outline-danger"
              block
              v-on:click="DeviceAction(ActionID, 'Deactivate')"
              >Deactivate</b-button
            ><br />
            <p class="infolabel">
              (No longer in use and being returned to Angel Guard if necessary)
            </p></b-card
          >
        </b-card-group> -->
      <!-- </div> -->
      <!-- <div v-if="Type == 'O-1'">
        <b-card-group>
          <b-card no-body
            ><b-button
              variant="outline-info"
              block
              v-on:click="O1DeviceActions(ActionID, 'Probes')"
              >Edit Probes</b-button
            ><br />
            <p class="infolabel">
              (Add or Remove probes assosciated with this device)
            </p></b-card
          > -->
          <!-- <b-card no-body
            ><b-button
              variant="outline-info"
              block
              v-on:click="O1DeviceActions(ActionID, 'Relocate')"
              >Relocate</b-button
            ><br />
            <p class="infolabel">
              (If monitoring is to be stopped completely in this location, being
              moved to new location etc)
            </p></b-card
          > -->
        <!-- </b-card-group>
      </div>
      <b-card no-body
        ><b-button
          variant="outline-info"
          block
          v-on:click="DeviceLinkModify(ActionID, Type)"
        >
          Device Links</b-button
        ><br />
        <p class="infolabel">
          (modify endpoints linked to device)
        </p></b-card
      >
    </b-modal> -->
    <!-- <b-modal
      id="WashbasinActionsModal"
      title="Washbasin Actions"
      hide-footer
      ref="WashbasinActionsModal"
      content-class="Modal"
      header-bg-variant="dark"
      footer-bg-variant="info"
      header-text-variant="light"
    >
      <b-card no-body>
        <b-button
          variant="outline-info"
          block
          v-on:click="WashbasinUnitActions(ActionID, 'MixedFlush')"
        >
          Request Mixed Flush</b-button
        ><br />
        <b-row
          ><b-col class="text-center"
            ><p class="infolabel">
              (Request Washbasin Flush Action)
            </p></b-col
          ></b-row
        >

        <b-row
          ><b-col class="text-center"
            ><p class="infolabel">
              Thermal and Chemical flushes cannnot be user initiated
            </p></b-col
          ></b-row
        >
      </b-card>
    </b-modal> -->

    <!-- <b-modal
      id="OutletActionsModal"
      title="Outlet Actions"
      hide-footer
      ref="OutletActionsModal"
      content-class="Modal"
      header-bg-variant="dark"
      footer-bg-variant="info"
      header-text-variant="light"
    >
      <b-card no-body v-if="this.DeviceStatus == 'Active'"
        ><b-button
          variant="outline-info"
          block
          v-on:click="OutletUnitActions(ActionID, 'RemoveOutlet')"
          >Deactivate Outlet</b-button
        ><br />
        <p class="infolabel">(Deactivate outlet on system)</p></b-card
      >
      <b-card no-body v-if="this.DeviceStatus != 'Active'"
        ><b-button
          variant="outline-info"
          block
          v-on:click="OutletUnitActions(ActionID, 'ReactivateOutlet')"
          >Activate Outlet</b-button
        ><br />
        <p class="infolabel">
          (Reactivate outlet if previously suspended)
        </p></b-card
      >
      <b-card no-body
        ><b-button
          variant="outline-info"
          block
          v-on:click="DeviceLinkModify(ActionID, Type)"
        >
          Device Links</b-button
        ><br />
        <p class="infolabel">
          (modify endpoints linked to device)
        </p></b-card
      >
    </b-modal>

    <b-modal
      id="SubGroupModal"
      title="Edit Location Groups"
      title-class="EditSubgroups"
      hide-footer
      ref="SubGroupModal"
      content-class="Modal"
      header-bg-variant="dark"
    >
      <h4>Select Location Groups for Endpoint</h4>
      <b-card align="left">
        <br />
        <b-form-checkbox-group
          v-model="selected"
          :options="SubGroupArray"
          name="SelectGroups"
          stacked
        ></b-form-checkbox-group>
        <br />
        <template #footer>
          <b-row>
            <b-col
              ><b-button
                size="sm"
                variant="outline-info"
                @click="SubmitUpdatedSubGroups(ID, Type, selected)"
                >Save
              </b-button></b-col
            >
            <b-col>
              <b-button
                size="sm"
                variant="outline-info"
                @click="$bvModal.hide('SubGroupModal')"
              >
                Cancel</b-button
              ></b-col
            >
          </b-row>
        </template>
      </b-card>
    </b-modal>
    <b-modal
      id="WashbasinDetails"
      title="Washbasin Details"
      ref="WashbasinDetails"
      content-class="Modal"
      header-bg-variant="light"
      footer-bg-variant="light"
      lazy
    >
      <b-card
        border-variant="dark"
        align="center"
        header-bg-variant="secondary"
        footer-tag="footer"
        header-text-variant="light"
      >
        <template #header>
          <h4 class="left">{{ EndpointCategory }} : {{ EndpointID }}</h4>
        </template>

        <b-card-body>
          <b-row
            ><b-col
              ><h4>
                <em>{{ this.EndpointDesc }}</em>
              </h4></b-col
            ></b-row
          >
          <b-row
            ><b-col
              ><h5>
                <em>{{ this.EndpointPos }}</em>
              </h5></b-col
            ></b-row
          >

          <b-card
            header-bg-variant=""
            align="center"
            border-variant="info"
            header-text-variant=""
            footer-bg-variant=""
          >
            <template #header>
              <b-row align-v="center"
                ><b-col
                  ><h6>Current Groups: {{ EndpointSub }}</h6></b-col
                >
              </b-row>
            </template>
            <template #footer>
              <b-row no-gutters>
                <b-col
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-b-modal.WashbasinActionsModal
                    v-on:click="showWashbasinActions(EndpointID, 'Washbasin')"
                    block
                    >Actions</b-button
                  ></b-col
                >
                <b-col
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-b-modal.DeviceDetailsModal
                    block
                    v-on:click="DeviceDetailReport(EndpointID, 'HW')"
                    >Device Details</b-button
                  ></b-col
                >
                <b-col
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    block
                    v-on:click="DeviceReportGen(EndpointID, 'HW')"
                    >Trend Report</b-button
                  ></b-col
                >
              </b-row>
            </template>
            <b-card v-if="this.EndpointList.length == 0"
              >Not Linked to any Location Groups</b-card
            >
            <b-list-group v-if="this.EndpointList.length != 0">
              <b-list-group-item v-for="item in this.EndpointList" :key="item">
                {{ item }}
              </b-list-group-item>
            </b-list-group>
            <b-button
              variant="outline-info"
              v-on:click="showSubModal(EndpointID, 'Washbasin', EndpointList)"
              size="sm"
            >
              Edit Location Groups
            </b-button>
          </b-card>
          <b-row
            ><b-col><br /></b-col
          ></b-row>
        </b-card-body>
      </b-card>
    </b-modal>
    <b-modal
      id="OutletDetails"
      title="Outlet Details"
      ref="OutletDetails"
      content-class="Modal"
      header-bg-variant="light"
      footer-bg-variant="light"
      lazy
    >
      <b-card
        border-variant="dark"
        align="center"
        header-bg-variant="secondary"
        footer-tag="footer"
        header-text-variant="light"
      >
        <b-card-sub-title class="mb-2"
          >{{ EndpointDept }} - {{ this.EndpointPos }}</b-card-sub-title
        >
        <template #header>
          <h4 class="left">{{ EndpointCategory }} : {{ EndpointID }}</h4>
        </template>
        <b-card-body>
          <h4>
            <em>{{ this.EndpointType }} - {{ this.EndpointFeed }}</em>
          </h4>
          <h5>
            <em>{{ this.EndpointNote }}</em>
          </h5>
          <b-row v-if="this.EndpointSentinel == 'Yes'"
            ><b-col><p>Sentinel Outlet</p></b-col></b-row
          >
          <b-card
            header-bg-variant=""
            align="center"
            border-variant="info"
            header-text-variant=""
            footer-bg-variant=""
          >
            <template #header>
              <b-row align-v="center"
                ><b-col
                  ><h6>Current Groups: {{ EndpointSub }}</h6></b-col
                ></b-row
              >
            </template>
            <template #footer>
              <b-row no-gutters>
                <b-col
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-b-modal.OutletActionsModal
                    v-on:click="
                      OutletActions(EndpointID, 'Outlet', EndpointStatus)
                    "
                    block
                    >Actions</b-button
                  ></b-col
                >
                <b-col></b-col>
                <b-col
                  ><b-button
                    variant="outline-info"
                    size="sm"
                    v-b-modal.DeviceDetailsModal
                    block
                    v-on:click="DeviceDetailReport(EndpointID, 'Outlet')"
                    >Outlet Details</b-button
                  ></b-col
                >
              </b-row>
            </template>
            <b-card v-if="this.EndpointList.length == 0"
              >Not Linked to any Location Groups</b-card
            >
            <b-list-group v-if="this.EndpointList.length != 0">
              <b-list-group-item v-for="item in this.EndpointList" :key="item">
                {{ item }}
              </b-list-group-item>
            </b-list-group>
            <b-button
              variant="outline-info"
              v-on:click="showSubModal(EndpointID, 'Outlet', EndpointList)"
              size="sm"
            >
              Edit Location Groups
            </b-button>
          </b-card>
          <b-row
            ><b-col><br /></b-col
          ></b-row>
        </b-card-body>
      </b-card>
    </b-modal> -->
    <!-- <b-modal
      id="AddNewOutletModal"
      title="Add new Outlet"
      ref="AddNewOutletModal"
      content-class="Modal"
      header-bg-variant="light"
      hide-footer
      lazy
    >
      <b-card>
        <AddNew @event-name="newaddEvent" view="Outlet"></AddNew>
      </b-card>
    </b-modal> -->
    <!-- <b-modal
      id="DeviceDetailsModal"
      title="Device Details"
      ref="DeviceDetailsModal"
      content-class="Modal"
      header-bg-variant="light"
      footer-bg-variant="light"
      lazy
    >
      <b-card>
        <DetailsData></DetailsData>
      </b-card>
    </b-modal> -->
</template>

<script>
import Vue from "vue";
// import { BIconPlusSquare } from "bootstrap-vue";
// import AddNew from "../views/AddNew.vue";
// import DetailsData from "../components/DetailData.vue";
import axios from "axios";
// import Routers from "../components/Routers.vue"
import DeviceAdminSUP from "../views/DeviceAdminSUP.vue";

import { IDToHuman } from "../CustomFunctions/HumanName.js";

export default {
  computed: {},
  components: {
    // BIconPlusSquare,
    // AddNew,
    // DetailsData,
    // Routers,
    DeviceAdminSUP
  },

  data() {
    return {
      tab: null,
      AssetTabs: null,
      UserHeaders: [],
      response: null,
      ArrTest: [],
      SubGroupArray: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      EndpointID: "",
      EndpointDesc: "",
      EndpointType: "",
      EndpointPos: "",
      EndpointSub: "",
      EndpointCategory: "",
      EndpointList: [],
      fields: [
        { key: "ID", variant: "primary" },
        // { key: "Type" },
        { key: "DeptFloor" },
        { key: "Position" },
        { key: "PositionNote" },
        { key: "Feed" },
        { key: "Status" },
        // { key: "LocationGroups" },
        { key: "show_details", label:"Details" },
      ],
      outletfields: [
        { key: "ID", variant: "primary" },
        { key: "Type" },
        { key: "DeptFloor" },
        { key: "LocationNote" },
        { key: "Position" },
        { key: "Sentinel" },
        { key: "Status" },
        { key: "LocationGroups" },
        { key: "show_details" },
      ],
      basinfields: [
        { key: "ID", variant: "primary" },
        { key: "Type" },
        { key: "DeptFloor" },
        { key: "PositionNote" },
        { key: "LocationGroups" },
        { key: "show_details" },
      ],
      showOverlay: false,
      duplicatefile: false,
      outletitems: [],
      deviceitems: [],
      o1items: [],
      c1items: [],
      basinitems: [],
      selected: [], // Must be an array reference!
      options: [],
      selectedlocation: localStorage.getItem("CurrentLocation"),
      dbFilterRiskLevel: "",
      filterInfo: [],
      dbFilterReturn: "",
      dbFilterMixed: "",
      dbFilterCold: "",
      dbFilterHot: "",
      dbFilterOutdoor: "",
      dbFilterOutletType: "",
      dbFilterSentinel: "",
      OutletTableData: [],
      EndpointSentinel: "",
      EndpointDept: "",
      EndpointFeed: "",
      EndpointNote: "",
      EndpointPosNote: "",
      ActionID: "",
      DeviceStatus: "",
      Type: "",
      ID: "",
      UserAccess: localStorage.getItem("accessGroup"),
      UserURN: localStorage.getItem("UserURN"),
      UserProfile: localStorage.getItem("profileportal"),
      DeviceIDToChange: { C1: [], O1: [] },

      IDsIhaveChanged: { C1: [], O1: [] },
      IDsToChange: { C1: [], O1: [] },
    };
  },

  async beforeMount() {
    this.AssetTabs = this.$tab;
    Vue.prototype.$tab = 0;
  },

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ClarenceDeviceLocation",
      LocationDict: [
        {
          Location: this.selectedlocation,
          FilterType: "",
          Feed: "",
          State: "",
        },
      ],
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        let C1DataArray = response.data.Values;
        for (let i = 0; i < C1DataArray.length; i++) {
          let PosNote = "";
          if (C1DataArray[i][8] == "O-1") {
            this.IDGetArrays(C1DataArray[i][0], "O1");
          }
          if (C1DataArray[i][8] == "C-1") {
            this.IDGetArrays(C1DataArray[i][0], "C1");
          }
          if (C1DataArray[i][2] != "") {
            PosNote = C1DataArray[i][2];
          } else if (C1DataArray[i][2] == "") {
            PosNote = "--";
          }

          this.deviceitems.push({
            ID: C1DataArray[i][0],
            Type: C1DataArray[i][8],
            DeptFloor: C1DataArray[i][1],
            Position: C1DataArray[i][3],
            PositionNote: PosNote,
            Feed: C1DataArray[i][4],
            LocationGroups: C1DataArray[i][6],
            show_details: "",
            grouplist: C1DataArray[i][7],
            Status: C1DataArray[i][9],
          });
        }
        
        for(let y=0;y<this.deviceitems.length;y++){
          if(this.deviceitems[y].Type == "O-1"){
            this.o1items.push(this.deviceitems[y])
          }
          else{
            this.c1items.push(this.deviceitems[y])
          }
        }

        this.SwitchToHuman("O1");
        this.SwitchToHuman("C1");
      });



    let LookUpUrlOutlet =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/outlets";
    let LookUpHeadersOutlet = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "LoadOutletLocation",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };

    axios
      .post(LookUpUrlOutlet, this.LookUpRequest, LookUpHeadersOutlet)
      .then((response) => {
        let OutletArray = response.data.Values;

        for (let i = 0; i < OutletArray.length; i++) {
          this.OutletTableData.push({
            ID: OutletArray[i][0],
            Type: OutletArray[i][1],
            Feed: OutletArray[i][2],
            DeptFloor: OutletArray[i][3],
            LocationNote: OutletArray[i][4],
            Position: OutletArray[i][5],
            Sentinel: OutletArray[i][6],
            Status: OutletArray[i][9],
            LocationGroups: OutletArray[i][7],
            grouplist: OutletArray[i][8],
          });
        }

        // Loop to create table data for Devices and Outlets, Outlets tab
      });

    let LookUpUrlHW =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeadersHW = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "WBDeviceLocation",
      LocationDict: [
        {
          Location: this.selectedlocation,
          FilterType: "",
          State: "",
        },
      ],
    };

    axios
      .post(LookUpUrlHW, this.LookUpRequest, LookUpHeadersHW)
      .then((response) => {
        this.basinitems = [];
        let HWDataArray = response.data.Values;
        for (let i = 0; i < HWDataArray.length; i++) {
          this.basinitems.push({
            ID: HWDataArray[i][0],
            Type: HWDataArray[i][3],
            DeptFloor: HWDataArray[i][1],
            PositionNote: HWDataArray[i][2],
            LocationGroups: HWDataArray[i][4],
            show_details: "",
            grouplist: HWDataArray[i][5],
          });
        }
      });
  },

  methods: {
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        let Names = await IDToHuman(this.IDsToChange.O1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        let Names = await IDToHuman(this.IDsToChange.C1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data, Type) {
      if (data.Type == "O-1" || Type == "O-1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (
            data.ID == this.DeviceIDToChange.O1[i].ID ||
            data == this.DeviceIDToChange.O1[i].ID
          ) {
            return this.DeviceIDToChange.O1[i].Name;
          }
        }
      } else {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (
            data.ID == this.DeviceIDToChange.C1[i].ID ||
            data == this.DeviceIDToChange.C1[i].ID
          ) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }
      return data.ID;
    },

    async IDGetArrays(ID, Type) {
      if (Type == "C1") {
        if (
          this.IDsIhaveChanged.C1.includes(ID) ||
          this.IDsToChange.C1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.C1.includes(ID) == false &&
          this.IDsToChange.C1.includes(ID) == false
        ) {
          this.IDsToChange.C1.push(ID);
        }
      }
      if (Type == "O1") {
        if (
          this.IDsIhaveChanged.O1.includes(ID) ||
          this.IDsToChange.O1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.O1.includes(ID) == false &&
          this.IDsToChange.O1.includes(ID) == false
        ) {
          this.IDsToChange.O1.push(ID);
        }
      }

    },

    DeviceDetailReport(ID, Type) {
      Vue.prototype.$DeviceID = ID;
      Vue.prototype.$DetailToShow = Type;
      Vue.prototype.$HumanName = this.getNewName(ID,Type);
    },
    DeviceReportGen(ID, DeviceType) {
      Vue.prototype.$DeviceID = ID;
      Vue.prototype.$DetailToShow = DeviceType;

      this.$router.push("/TrendData");
    },

    DeviceLinkModify(id, type) {
      Vue.prototype.$DeviceID = id;
      Vue.prototype.$DetailToShow = type;

      this.$router.push("/LinkDevices");
    },
    updateTab(tab) {
      this.AssetTabs = tab;
    },
    // showWashbasinActions(device, type) {
    //   this.ActionID = device;
    //   this.Type = type;
    //   this.$refs["WashbasinActionsModal"].show(this.ActionID, this.Type);
    // },
    // WashbasinUnitActions(device) {
    //   let LookUpUrl =
    //     "https://3y0mr9gcl5.execute-api.eu-west-2.amazonaws.com/" +
    //     this.$environment +
    //     "/unit";
    //   let LookUpHeaders = this.$apikeyPost;
    //   this.LookUpRequest = {
    //     RequestType: "Flush",
    //     UnitType: "",
    //     UnitDict: [
    //       {
    //         FlushType: "Mixed",
    //         UserURN: this.UserURN,
    //         UnitID: device,
    //       },
    //     ],
    //   };

    //   axios
    //     .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
    //     .then((response) => {
    //       if (response.data.Values == "Invalid Flush Request") {
    //         alert(
    //           "Unit already has flush pending, Action cannot be completed until all previous actions completed"
    //         );
    //       } else {
    //         alert(
    //           "Flush Request has been sent to Washbasin Unit and will be carried out when safe to do so."
    //         );
    //       }
    //     });

    //   this.$refs["WashbasinActionsModal"].hide();
    // },
    // OutletUnitActions(device, action) {
    //   let RequestVar = action;

    //   let LookUpUrl =
    //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //     this.$environment +
    //     "/outlets";
    //   let LookUpHeaders = this.$apikeyPost;
    //   this.LookUpRequest = {
    //     RequestType: RequestVar,
    //     DataDict: [
    //       {
    //         OutletID: device,
    //       },
    //     ],
    //   };

    //   axios
    //     .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
    //     .then((response) => {
    //       response;
    //     });

    //   if (action == "RemoveOutlet") {
    //     alert("Outlet will be Deactivated on the system.");
    //   }
    //   if (action == "ReactivateOutlet") {
    //     alert("Outlet will be Reactivated on the system.");
    //   }

    //   this.$refs["OutletActionsModal"].hide();
    //   this.$refs["OutletDetails"].hide();
    //   this.ReloadTables("Outlet");
    // },

    // OutletActions(device, type, status) {
    //   this.ActionID = device;
    //   (this.Type = type), (this.DeviceStatus = status);
    //   this.$refs["OutletActionsModal"].show(
    //     this.ActionID,
    //     this.Type,
    //     this.DeviceStatus
    //   );
    // },
    O1DeviceActions(device, action) {
      alert("O1 action pressed " + device + ":" + action);
    },

    showClarenceModal: function(item) {
      this.EndpointDept = item.DeptFloor;
      this.EndpointID = item.ID;
      this.EndpointType = item.Type;
      this.EndpointPos = item.Position;
      this.EndpointPosNote = item.PositionNote;
      this.EndpointStatus = item.Status;

      this.EndpointSub = item.LocationGroups;
      this.EndpointCategory = item.Type;
      if ((this.EndpointSub == 1) & (this.EndpointType == "O-1")) {
        this.EndpointList = item.grouplist;
      } else {
        this.EndpointList = item.grouplist;
      }
      this.$refs["ClarenceDetails"].show(
        this.EndpointID,
        this.EndpointType,
        this.EndpointPos,
        this.EndpointPosNote,
        this.EndpointSub,
        this.EndpointCategory,
        this.EndpointList,
        this.EndpointDept,
        this.EndpointStatus
      );
    },
    showWashbasinModal: function(item, Cat) {
      this.EndpointID = item.ID;
      this.EndpointDesc = item.Description;
      this.EndpointType = item.Type;
      this.EndpointPos = item.Position;
      this.EndpointSub = item.LocationGroups;
      this.EndpointCategory = Cat;
      this.EndpointList = item.grouplist;
      this.$refs["WashbasinDetails"].show(
        this.EndpointID,
        this.EndpointDesc,
        this.EndpointType,
        this.EndpointPos,
        this.EndpointSub,
        this.EndpointCategory,
        this.EndpointList
      );
    },
    showOutletModal: function(item, Cat) {
      this.EndpointID = item.ID;
      this.EndpointType = item.Type;
      this.EndpointPos = item.Position;
      this.EndpointCategory = Cat;
      this.EndpointDept = item.DeptFloor;
      this.EndpointFeed = item.Feed;
      this.EndpointNote = item.LocationNote;
      this.EndpointSentinel = item.Sentinel;
      this.EndpointList = item.grouplist;
      this.EndpointStatus = item.Status;
      this.$refs["OutletDetails"].show(
        this.EndpointID,
        this.EndpointType,
        this.EndpointPos,
        this.EndpointCategory,
        this.EndpointDept,
        this.EndpointFeed,
        this.EndpointNote,
        this.EndpointSentinel,
        this.EndpointList,
        this.EndpointStatus
      );
    },
    showAddOutletModal: function() {
      this.$refs["AddNewOutletModal"].show();
    },

    showSubModal: function(ID, Type, List) {
      this.getSubGroupList();
      this.selected = List;
      this.ID = ID;
      if (Type == "C-1" || Type == "O-1") {
        this.Type = "Clarence";
      } else {
        this.Type = Type;
      }

      this.$refs["SubGroupModal"].show(this.selected, this.ID, this.Type);
    },

    resetValue: function(category) {
      (this.dbFilterRiskLevel = 0),
        (this.dbFilterReturn = ""),
        (this.dbFilterMixed = ""),
        (this.dbFilterCold = ""),
        (this.dbFilterHot = ""),
        (this.dbFilterOutdoor = ""),
        (this.filterInfo = []),
        (this.dbFilterOutletType = ""),
        (this.dbFilterSentinel = "");
      this.ReloadTables(category);
    },

    // filterEndpointData: function(category) {
    //   let TypeFilter = [];
    //   let FeedFilter = [];
    //   let StateFilter = "";
    //   this.filterInfo = [];
    //   let OutletTap = "";
    //   if (category == "Clarence" || category == "Washbasin") {
    //     if (this.dbFilterRiskLevel != "") {
    //       let PositionName = "";
    //       if (this.dbFilterRiskLevel == "1") {
    //         PositionName = "Extremely High Risk";
    //       } else if (this.dbFilterRiskLevel == "2") {
    //         PositionName = "High Risk";
    //       } else if (this.dbFilterRiskLevel == "3") {
    //         PositionName = "Moderate Risk";
    //       } else if (this.dbFilterRiskLevel == "4") {
    //         PositionName = "Low Risk";
    //       }

    //       this.filterInfo.push({
    //         FilterName: "Device State",
    //         FilterVar: PositionName,
    //       });

    //       TypeFilter.push("State");
    //       StateFilter = this.dbFilterRiskLevel;
    //     }
    //     if (
    //       this.dbFilterCold != "" ||
    //       this.dbFilterHot != "" ||
    //       this.dbFilterMixed != "" ||
    //       this.dbFilterOutdoor != "" ||
    //       this.dbFilterReturn != ""
    //     ) {
    //       let FilterFeedVar = "";

    //       if (this.dbFilterCold == true) {
    //         FilterFeedVar = "Cold Feed";
    //         this.filterInfo.push({
    //           FilterName: "Feed",
    //           FilterVar: FilterFeedVar,
    //         });
    //         FeedFilter.push("Cold");
    //       }
    //       if (this.dbFilterHot == true) {
    //         FilterFeedVar = "Hot Feed";
    //         this.filterInfo.push({
    //           FilterName: "Feed",
    //           FilterVar: FilterFeedVar,
    //         });
    //         FeedFilter.push("Hot");
    //       }
    //       if (this.dbFilterMixed == true) {
    //         FilterFeedVar = "Mixed Feed";
    //         this.filterInfo.push({
    //           FilterName: "Feed",
    //           FilterVar: FilterFeedVar,
    //         });
    //         FeedFilter.push("Mixed");
    //       }
    //       if (this.dbFilterOutdoor == true) {
    //         FilterFeedVar = "Outdoor";
    //         this.filterInfo.push({
    //           FilterName: "Feed",
    //           FilterVar: FilterFeedVar,
    //         });
    //         TypeFilter.push("Outdoor");
    //       }
    //       if (this.dbFilterReturn == true) {
    //         FilterFeedVar = "Return";
    //         this.filterInfo.push({
    //           FilterName: "Feed",
    //           FilterVar: FilterFeedVar,
    //         });
    //         FeedFilter.push("Return");
    //       }

    //       TypeFilter.push("Feed");
    //     }
    //   } else if (category == "Outlet") {
    //     let FilterOutletVar = "";
    //     if (this.dbFilterOutletType != 0) {
    //       if (this.dbFilterOutletType == 1) {
    //         FilterOutletVar = "Cold Tap";
    //         OutletTap = "Cold Tap";
    //       } else if (this.dbFilterOutletType == 2) {
    //         FilterOutletVar = "Hot Tap";
    //         OutletTap = "Hot Tap";
    //       } else if (this.dbFilterOutletType == 3) {
    //         FilterOutletVar = "Mixed Tap";
    //         OutletTap = "Mixed Tap";
    //       } else if (this.dbFilterOutletType == 4) {
    //         FilterOutletVar = "Shower";
    //         OutletTap = "Shower";
    //       } else if (this.dbFilterOutletType == 5) {
    //         FilterOutletVar = "Other";
    //         OutletTap = "Other";
    //       }
    //       this.filterInfo.push({
    //         FilterName: "Outlet Type",
    //         FilterVar: FilterOutletVar,
    //       });
    //       TypeFilter.push("Type");
    //     }
    //     if (this.dbFilterSentinel != 0) {
    //       let FilterSentinelVar = "";
    //       if (this.dbFilterSentinel == "1") {
    //         FilterSentinelVar = "True";
    //         TypeFilter.push("Sentinel");
    //       }
    //       this.filterInfo.push({
    //         FilterName: "Sentinel Filter",
    //         FilterVar: FilterSentinelVar,
    //       });
    //     }
    //   }

    //   this.FilterTables(
    //     TypeFilter,
    //     FeedFilter,
    //     StateFilter,
    //     OutletTap,
    //     category
    //   );
    // },

    getSubGroupList() {
      this.SubGroupArray = [];
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "LocationSubgroup",
        LocationDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };

      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          let SubGroupData = response.data.Values;
          for (let i = 0; i < SubGroupData.length; i++) {
            this.SubGroupArray.push({
              text: SubGroupData[i][0],
              value: SubGroupData[i][0],
            });
          }
        });
    },

    // SubmitUpdatedSubGroups(ID, Type, NewList) {
    //   let RefreshTable = Type;

    //   let LookUpUrl =
    //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //     this.$environment +
    //     "/locations";
    //   let LookUpHeaders = this.$apikeyPost;
    //   this.LookUpRequest = {
    //     RequestType: "EditEndpointGroups",
    //     LocationDict: [
    //       {
    //         EndpointID: ID,
    //         EndpointType: Type,
    //         LocationGroups: NewList,
    //       },
    //     ],
    //   };

    //   axios
    //     .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
    //     .then((response) => {
    //       response;
    //     });

    //   alert("Location Group Update Submitted");
    //   this.$refs["SubGroupModal"].hide();

    //   if (RefreshTable == "Clarence") {
    //     this.$refs["ClarenceDetails"].hide();
    //     this.ReloadTables("Clarence");
    //   }

    //   if (RefreshTable == "Washbasin") {
    //     this.$refs["WashbasinDetails"].hide();
    //     this.ReloadTables("Washbasin");
    //   }

    //   if (RefreshTable == "Outlet") {
    //     this.$refs["OutletDetails"].hide();
    //     this.ReloadTables("Outlet");
    //   }
    // },

    DeviceAction(id, Type) {
      this.ActionID = id;
      this.ActionType = Type;

      if (this.ActionType == "Suspend") {
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/device";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "Suspend",
          DeviceDict: [{ DeviceID: id }],
        };

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert("Device Suspended");
            this.HistorySubmit("Suspended Device " + id);
            this.$refs["ClarenceActionsModal"].hide();
            this.$refs["ClarenceDetails"].hide();
            this.ReloadTables("Clarence");
          });
      }
      if (this.ActionType == "Activate") {
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/device";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "Reactivate",
          DeviceDict: [{ DeviceID: id }],
        };

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert("Device Activated");
            this.HistorySubmit("Activated Device " + id);
            this.$refs["ClarenceActionsModal"].hide();
            this.$refs["ClarenceDetails"].hide();
            this.ReloadTables("Clarence");
          });
      }
    },
    HistorySubmit(Note) {
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });

      let LookUpURLHist =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/adminhistory";
      let LookUpHeadersHist = this.$apikeyPost;
      this.LookUpRequest = {
        UserURN: this.UserURN,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: Note,
        ProfilePortal: this.UserProfile,
      };
      axios
        .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
        .then((response) => {
          response;
        });
    },

    ClarenceActions(id, cat, status) {
      this.ActionID = id;
      this.Type = cat;
      this.DeviceStatus = status;
      this.$refs["ClarenceActionsModal"].show(
        this.ActionID,
        this.Type,
        this.DeviceStatus
      );
    },

    ReloadTables(table) {
      if (table == "Outlet") {
        this.OutletArray = [];
        this.OutletTableData = [];
        this.OutDataArray = [];
        this.outletitems = [];
        let LookUpUrlOutlet =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/outlets";
        let LookUpHeadersOutlet = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "LoadOutletLocation",
          DataDict: [
            {
              Location: this.selectedlocation,
            },
          ],
        };

        axios
          .post(LookUpUrlOutlet, this.LookUpRequest, LookUpHeadersOutlet)
          .then((response) => {
            let OutletArray = response.data.Values;

            for (let i = 0; i < OutletArray.length; i++) {
              this.OutletTableData.push({
                ID: OutletArray[i][0],
                Type: OutletArray[i][1],
                Feed: OutletArray[i][2],
                DeptFloor: OutletArray[i][3],
                LocationNote: OutletArray[i][4],
                Position: OutletArray[i][5],
                Sentinel: OutletArray[i][6],
                Status: OutletArray[i][9],
                LocationGroups: OutletArray[i][7],
                grouplist: OutletArray[i][8],
              });
            }

            // Loop to create table data for Devices and Outlets, Outlets tab
          });
      }
      if (table == "Clarence") {
        this.C1DataArray = [];
        this.c1items = [];
        this.O1DataArray = [];

        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "ClarenceDeviceLocation",
          LocationDict: [
            {
              Location: this.selectedlocation,
              FilterType: "",
              Feed: "",
              State: "",
            },
          ],
        };

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            let C1DataArray = response.data.Values;
            for (let i = 0; i < C1DataArray.length; i++) {
              let PosNote = "";

              if (C1DataArray[i][2] != "") {
                PosNote = C1DataArray[i][2];
              } else if (C1DataArray[i][2] == "") {
                PosNote = "--";
              }

              this.c1items.push({
                ID: C1DataArray[i][0],
                Type: C1DataArray[i][8],
                DeptFloor: C1DataArray[i][1],
                Position: C1DataArray[i][3],
                PositionNote: PosNote,
                Feed: C1DataArray[i][4],
                LocationGroups: C1DataArray[i][6],
                show_details: "",
                grouplist: C1DataArray[i][7],
                Status: C1DataArray[i][9],
              });
            }
          });
      }
      if (table == "Washbasin") {
        this.basinitems = [];
        this.HWDataArray = [];

        let LookUpUrlHW =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeadersHW = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "WBDeviceLocation",
          LocationDict: [
            {
              Location: this.selectedlocation,
              FilterType: "",
              State: "",
            },
          ],
        };

        axios
          .post(LookUpUrlHW, this.LookUpRequest, LookUpHeadersHW)
          .then((response) => {
            this.basinitems = [];
            let HWDataArray = response.data.Values;
            for (let i = 0; i < HWDataArray.length; i++) {
              this.basinitems.push({
                ID: HWDataArray[i][0],
                Type: HWDataArray[i][3],
                DeptFloor: HWDataArray[i][1],
                PositionNote: HWDataArray[i][2],
                LocationGroups: HWDataArray[i][4],
                show_details: "",
                grouplist: HWDataArray[i][5],
              });
            }
          });
      }
    },
    // FilterTables(FilterType, Feed, State, OutletTap, category) {
    //   if (category == "Clarence") {
    //     this.C1DataArray = [];
    //     this.c1items = [];
    //     this.O1DataArray = [];

    //     let LookUpUrl =
    //       "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //       this.$environment +
    //       "/locations";
    //     let LookUpHeaders = this.$apikeyPost;
    //     this.LookUpRequest = {
    //       RequestType: "ClarenceDeviceLocation",
    //       LocationDict: [
    //         {
    //           Location: this.selectedlocation,
    //           FilterType: FilterType,
    //           Feed: Feed,
    //           State: State,
    //         },
    //       ],
    //     };

    //     axios
    //       .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
    //       .then((response) => {
    //         let C1DataArray = response.data.Values;
    //         for (let i = 0; i < C1DataArray.length; i++) {
    //           let PosNote = "";

    //           if (C1DataArray[i][2] != "") {
    //             PosNote = C1DataArray[i][2];
    //           } else if (C1DataArray[i][2] == "") {
    //             PosNote = "--";
    //           }

    //           this.c1items.push({
    //             ID: C1DataArray[i][0],
    //             Type: C1DataArray[i][8],
    //             DeptFloor: C1DataArray[i][1],
    //             Position: C1DataArray[i][3],
    //             PositionNote: PosNote,
    //             Feed: C1DataArray[i][4],
    //             LocationGroups: C1DataArray[i][6],
    //             show_details: "",
    //             grouplist: C1DataArray[i][7],
    //             Status: C1DataArray[i][9],
    //           });
    //         }
    //       });
    //   }
    //   if (category == "Washbasin") {
    //     let LookUpUrlHW =
    //       "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //       this.$environment +
    //       "/locations";
    //     let LookUpHeadersHW = this.$apikeyPost;
    //     this.LookUpRequest = {
    //       RequestType: "WBDeviceLocation",
    //       LocationDict: [
    //         {
    //           Location: this.selectedlocation,
    //           FilterType: FilterType,
    //           State: State,
    //         },
    //       ],
    //     };

    //     axios
    //       .post(LookUpUrlHW, this.LookUpRequest, LookUpHeadersHW)
    //       .then((response) => {
    //         this.basinitems = [];
    //         let HWDataArray = response.data.Values;
    //         for (let i = 0; i < HWDataArray.length; i++) {
    //           this.basinitems.push({
    //             ID: HWDataArray[i][0],
    //             Type: HWDataArray[i][3],
    //             DeptFloor: HWDataArray[i][1],
    //             PositionNote: HWDataArray[i][2],
    //             LocationGroups: HWDataArray[i][4],
    //             show_details: "",
    //             grouplist: HWDataArray[i][5],
    //           });
    //         }
    //       });
    //   }
    //   if (category == "Outlet") {
    //     let LookUpUrlOut =
    //       "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //       this.$environment +
    //       "/locations";
    //     let LookUpHeadersOut = this.$apikeyPost;
    //     this.LookUpRequest = {
    //       RequestType: "OutletLocation",
    //       LocationDict: [
    //         {
    //           Location: this.selectedlocation,
    //           FilterType: FilterType,
    //           Type: OutletTap,
    //         },
    //       ],
    //     };

    //     axios
    //       .post(LookUpUrlOut, this.LookUpRequest, LookUpHeadersOut)
    //       .then((response) => {
    //         this.OutletArray = [];
    //         this.OutletTableData = [];
    //         this.OutDataArray = [];
    //         this.outletitems = [];
    //         let OutletArray = response.data.Values;

    //         for (let i = 0; i < OutletArray.length; i++) {
    //           this.OutletTableData.push({
    //             ID: OutletArray[i][0],
    //             Type: OutletArray[i][1],
    //             Feed: OutletArray[i][5],
    //             DeptFloor: OutletArray[i][3],
    //             LocationNote: OutletArray[i][4],
    //             Position: OutletArray[i][6],
    //             Status: OutletArray[i][10],
    //             LocationGroups: OutletArray[i][7],
    //             Sentinel: OutletArray[i][8],
    //             grouplist: OutletArray[i][9],
    //           });
    //         }
    //       });
    //   }
    // },

    // newaddEvent(data) {
    //   if (data == "Outlet") {
    //     this.$refs["AddNewOutletModal"].hide();
    //     this.ReloadTables("Outlet");
    //   }
    // },
  },
  watch: {
    AssetTabs() {
      (this.dbFilterRiskLevel = 0),
        (this.dbFilterReturn = ""),
        (this.dbFilterMixed = ""),
        (this.dbFilterCold = ""),
        (this.dbFilterHot = ""),
        (this.dbFilterOutdoor = ""),
        (this.filterInfo = []),
        (this.dbFilterOutletType = ""),
        (this.dbFilterSentinel = "");
    },
  },
};
</script>

<style>
input[type="text"],
select {
  width: 100%;
  padding: 5px 5px 5px 5px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  background-color: rgb(245, 245, 245);
}

h4 {
  text-align: center;
}

#UnitRAG {
  padding-top: 5px;
  margin-top: 5px;
}

#leftRow {
  margin: 0;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}

h5 {
  font-size: 0.95rem;
  padding-top: 5px;
  padding-bottom: 5px;
}

#TempCol {
  text-align: center;
  margin-bottom: 5px;
}

#TempColMid {
  text-align: center;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
}

#ScoreBar {
  height: 100%;
  width: 85%;
  margin: 0 auto;
  padding-top: 5%;
  padding-bottom: 5%;
}

#OverallScoreContainer {
  position: relative;
  border: solid 1px black;
}

#ScoreSlider {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 409;
  width: 100%;
}

#Selector {
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
}

#ButtonRow {
  padding-bottom: 1.5rem;
  border-bottom: solid 2px gray;
  margin-left: 3rem;
  margin-right: 3rem;
}

#FilterButtonRow {
  padding-bottom: 1.5rem;
}

label {
  margin: 0;
}

.DeviceOverview {
  width: 48%;
  float: left;
  color: black;
  margin-right: 2%;
  flex: 1;
}

.PieChartDiv {
  width: 50%;
  float: right;
}

.DeviceInfoTop {
  display: flex;
  width: 100%;
  overflow: hidden;
}
.chartBox {
  height: 95%;
  margin: 1rem 1rem 0rem 1rem;
  text-align: left;
  background-color: #eeeeee;
  border: 0;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.DoughnutChart {
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 225px;
}

/* Updates 240122 */

.totalText {
  width: 100%;
  text-align: center;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  font-size: 1rem;
}
.rightCountBox {
  float: right;
  width: 48%;
}
.leftCountBox {
  float: left;
  width: 48%;
}
.totalBox {
  margin: 1rem 1rem 0rem 1rem;
  padding: 1rem 1.5rem 1rem 1.5rem;
  text-align: center;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
}
.stateCountText {
  font-size: 3rem;
  padding: 0 !important;
}

.lowRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  text-align: left;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
  cursor: context-menu;
}
.modRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  text-align: left;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
  cursor: context-menu;
}
.highRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  text-align: left;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
  cursor: context-menu;
}
.extHighRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  text-align: left;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
  cursor: context-menu;
}

.legendText {
  color: black;
  font-size: 0.75rem;
}

.checkboxDiv {
  margin-right: 70%;
  border: none;
}

.checkboxWMC {
  margin-bottom: 1rem;
}

.supportTextArea {
  min-height: 5rem;
  width: 100%;
  border-radius: 10px;
  padding: 0.5rem;
}
.noteCol {
  text-align: center;
  background-color: white;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  border: solid 1px rgb(180, 180, 180);
  padding: 0.5rem;
}

.notePreviewRow {
  background-color: rgb(245, 245, 245);
  padding-top: 0.25rem;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  margin-top: 1rem;
}
.notesCollapsible {
  background: rgba(200, 200, 200, 0);
  border: none;
}
.noteTitleP {
  text-align: center;
  font-weight: 600;
  padding-top: 0.5rem;
}
.noteDetails {
  text-align: center;
}
.deleteNoteButton {
  background-color: rgb(245, 245, 245);
  border-radius: 15px;
  border: solid 1px black;
}
.deleteNoteButton:hover {
  background-color: rgb(255, 255, 255);
}
/* .notePreivewContent{
} */

.NewNoteModal {
  text-align: center;
  align-items: center;
  align-content: center;
}

.NewNoteTitle {
  width: 100%;
  padding: 7px 7px 7px 7px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 15px;
  background-color: rgb(245, 245, 245);
}
.NewNoteTopRow {
  margin-bottom: 1rem;
}
.NewNoteBottomRow {
  margin-bottom: 1rem;
}
.NotesModalContainerDiv {
  text-align: center;
}
.NoteContainer {
  margin-bottom: 1rem;
  overflow-x: scroll;
  max-height: 55vh;
}

.calibContainer {
  width: 90%;
  border-radius: 15px;
  border: solid 1px rgb(0, 204, 255);
  margin-left: 5%;
  background: #eeeeee;
}
.col-line-mod {
  border-top: solid 1px rgb(200, 200, 200);
  width: 95%;
  margin-left: 2.5%;
  margin-top: 2rem;
}
.flowCheckBox {
  text-align: center;
}
.caliConfirm {
  width: 80%;
  margin-left: 9%;
}
.headFlow {
  margin-top: 4px;
  font-weight: bold;
  color: #585858;
  padding-top: 1rem;
  width: 100%;
  text-align: center;
}
.flowCheck {
  padding-top: 1rem;
  margin-top: 4px;
}

p.cardhead {
  color: gray;
  text-decoration: underline;
  font-size: medium;
  margin-bottom: 0;
}

p.cardheaddouble {
  color: gray;
  text-decoration: underline;
  font-size: small;
  margin-bottom: 0;
}

p.doublereadings {
  color: black;
  font-size: small;
  padding: 0;
  margin: 0;
}

p.cardbody {
  color: black;
  font-size: medium;
  margin: 0.25rem;
}

p.filterhead {
  color: gray;
  font-size: small;
  margin: 0.25rem;
  font-weight: bold;
}

p.filterbody {
  color: gray;
  font-size: small;
  margin: 0.25rem;
}

.left {
  float: left;
}

.right {
  float: right;
}

.cardcol {
  border: solid lightgray;
}

.list-group-item {
  border: none;
}

input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid cadetblue;
  border-radius: 5px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: cadetblue;
}

#Table {
  margin: auto;
  text-align: center;
}

#cancel-label {
  color: white;
  font-size: large;
}

.Upload label {
  font-size: 15px;
}

.modal {
  text-align: center;
}

.card-body {
  padding: 10px;
}

.card-footer {
  padding: 0px;
  text-align: center;
}

.left {
  float: left;
}

.right {
  float: right;
}

.legendText {
  color: black;
  font-size: 0.75rem;
}

.cardcol {
  border: solid lightgray;
  margin-left: 5px;
  margin-right: 5px;
}

.highrisk {
  background-color: #f05e16;
  color: #000;
}

.moderaterisk {
  background-color: rgb(252, 252, 38);
  color: #000;
}

.cardhead {
  color: gray;
  text-decoration: underline;
  font-size: 16px;
  margin-bottom: 0;
}
.EditSubgroups {
  color: #eeeeee;
}
</style>
